import { render, staticRenderFns } from "./ShareBar.vue?vue&type=template&id=00962184&"
import script from "./ShareBar.vue?vue&type=script&lang=js&"
export * from "./ShareBar.vue?vue&type=script&lang=js&"
import style0 from "./ShareBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShareButtons: require('/app/components/share/ShareButtons.vue').default})
